
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 96","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44 12v62.344L22.828 53.172a4 4 0 10-5.656 5.657l28 28a4 4 0 005.656 0l28-28A3.989 3.989 0 0080 56a4 4 0 00-6.828-2.828L52 74.344V12a4 4 0 00-8 0z"}})])
          )
        }
      }
    